// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"1c98fbe55fbc9f24f8b2","147":"da91590572b504d0097a","251":"5b1957a4e3e12df5c851","352":"435fa6d9276034231b3b","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};